import { policyTipsOverrideLinkLabel } from './PolicyTipsDetails.locstring.json';
import { policyTipsOverrideLink } from '../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import DlpPolicyMatchDetail from 'owa-service/lib/contract/DlpPolicyMatchDetail';
import DlpPolicyTipAction from 'owa-service/lib/contract/DlpPolicyTipAction';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import getInfoBarLinkColorStyle from 'owa-info-bar/lib/utils/getInfoBarLinkColorStyle';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import setOverrideJustification from '../actions/setOverrideJustification';
import showPolicyTipsOverrideDialog from '../utils/showPolicyTipsOverrideDialog';

import { getHighestPriorityPolicyTipMatchDetail } from '../utils/getHighestPriorityPolicyTipMatchDetail';
import { isOverrideLinkVisible } from '../utils/isOverrideLinkVisible';
import { PolicyTipsDetailsLearnMore } from './PolicyTipsDetailsLearnMore';
import { PolicyTipsDetailsRecipient } from './PolicyTipsDetailsRecipient';

const classNames = require('classnames');
const styles = require('./PolicyTipsDetails.scss');

export interface PolicyTipsDetailsProps {
    viewState: PolicyTipsViewState;
    onRecipientRemoveClick: (recipients: EmailAddressWrapper[]) => void;
    getRecipientByEmailAddress: (emailAddress: string) => EmailAddressWrapper;
}

const overridePolicyTip = (
    viewState: PolicyTipsViewState,
    matchDetail: DlpPolicyMatchDetail
) => () => {
    if (matchDetail.Action == DlpPolicyTipAction.RejectUnlessSilentOverride) {
        setOverrideJustification(viewState, '');
    } else {
        showPolicyTipsOverrideDialog(viewState);
    }
};

export const PolicyTipsDetails = (props: PolicyTipsDetailsProps) => {
    const matchDetail = getHighestPriorityPolicyTipMatchDetail(
        props.viewState.succeededPolicyMatch
    );
    const linkStyle = classNames(styles.link, getInfoBarLinkColorStyle(null));
    const matchedRecipients = matchDetail.Recipients?.map(recipient => {
        return props.getRecipientByEmailAddress(recipient.EmailAddress);
    });
    return (
        <>
            {matchDetail.Recipients && matchDetail.Recipients.length > 0 && (
                <div>
                    {matchedRecipients && matchedRecipients.length > 0 && (
                        <PolicyTipsDetailsRecipient
                            emailAddresses={matchedRecipients}
                            onRecipientRemoveClick={props.onRecipientRemoveClick}
                            classNameForLink={linkStyle}
                        />
                    )}
                </div>
            )}
            {isOverrideLinkVisible(matchDetail) && (
                <>
                    <span>{loc(policyTipsOverrideLinkLabel)}</span>{' '}
                    <a
                        className={linkStyle}
                        onClick={overridePolicyTip(props.viewState, matchDetail)}>
                        {loc(policyTipsOverrideLink)}
                    </a>
                </>
            )}
            <div>
                <PolicyTipsDetailsLearnMore viewState={props.viewState} linkStyle={linkStyle} />
            </div>
        </>
    );
};
